module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("5")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("Mrs. Brewer’s Rooming House")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("ong before King awoke on Thursday, April 4, Andrew Young and Jim Lawson headed to federal court to assist the effort to get the temporary injunction against the march either lifted or modified. King was finally up in time to go to the Lorraine’s grill with Abernathy, where they had their favorite meal, fried catfish. After lunch, King convened a meeting with his aides in his motel room, to discuss the best ways to neutralize the Invaders. “Some of the younger staff members were nervous,” recalled Abernathy. “Martin was impatient with them. ‘There was no more reason to be frightened now than in the past,’ he said. ‘I’d rather be dead than afraid,’ he said contemptuously, as much to himself as to the rest of us.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-1",
      "id": "ch05-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King’s brother, Alfred Daniel (A.D.), had arrived unexpectedly the night before. After the staff meeting ended, King joined A.D. in his first-floor room and the two called Mama King and spoke to her for nearly an hour."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-2",
      "id": "ch05-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Later, King complained that he had not heard all day from Young and was anxious to know what had happened in court. Around 4:30, Young appeared, but before he could even announce that the judge was willing to issue a modified order the following Monday, King “started fussing in a kind of joking way about ‘why don’t you call and let me know what’s going on? We’re sitting here all day long waiting to hear from you and you didn’t call.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-3",
      "id": "ch05-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Then King picked up a pillow "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("and threw it at Young, who quickly threw it back. In a moment, half a dozen men were scrambling around the room, laughing hysterically and hurling pillows at one another. It lasted only a few minutes until they all collapsed from exhaustion. “Occasionally, he would get in those kinds of hilarious moods,” recalled Young.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Around 5:30, King returned to Room 306 with Abernathy. He watched the evening news and some of his aides wandered in and out, chatting with him about minor matters. With his tie loosened, King lay across the large bed and seemed more relaxed than he had in days.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])])]), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Half a block away, at 484 South Main Street, a law enforcement team was ensconced in Fire Station No. 2. The newly constructed one-story building, of light brick with large glass windows, was to the left of the motel and about 150 feet away. There, when King was in town, law enforcement watched him. For this April visit, because of the recent violence and the possibility of more, surveillance on King had been increased. Not only were Memphis police officers there observing with binoculars focused through small cutouts in newspapers pasted over the windows, but FBI agents were also on the scene, and even several military intelligence officers wandered in occasionally."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-4",
      "id": "ch05-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" King and his aides expected there were informants around them, and constant police surveillance wherever they traveled. J. Edgar Hoover had publicly declared war on King years earlier, obsessed with what he thought were King’s pro-Communist connections, as well as his sex life. For several years, the FBI had conducted a campaign, sometimes illegal, of harassment, interference, infiltration, and steady surveillance of King and the SCLC. The Johnson administration had drafted military intelligence—against the desires of some leading officers—to assist in monitoring the civil unrest and antiwar activities that were building powerfully in the late 1960s."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-5",
      "id": "ch05-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Memphis police officers most responsible for surveillance on April 4 were black: a detective, Ed Redditt, and a patrolman, W. B. Richmond. Both knew most of the black personalities in the city. They recorded the names of people and the times they visited King as well as the license numbers of cars that came to the hotel. If King left the Lorraine, they were to follow him and report on his activities. The Memphis police, the FBI, and military intelligence all deny that they had any electronic surveillance on King at the Lorraine, although since it would have been illegal, none of them would be expected to admit it even if they had."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-05-1",
      "id": "fn05-1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Across the street from the Lorraine Motel was a retaining wall and a slope overgrown with weeds and trees leading up to the rear of two adjacent two-story brick buildings. A covered passageway connected the two buildings. They fronted on South Main Street, the next block over from the motel. The ground floor had stores—a bar and grill, and a jukebox repair and record shop. The second floors had been converted into separate wings of a single rooming house. It was in a commercial area largely populated with vagrants and winos, and on the border of Memphis’s black community. Pawnshops were the area’s mainstays. Between 3:00 and 3:30 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". on April 4, there was a knock on the door of Room 2, which served as the building’s office. The manager, Mrs. Bessie Brewer, a heavyset woman in her thirties with her hair in curlers, dressed in jeans and a man’s wrinkled checked shirt, opened the door as far as the chain would permit. Standing there was a trim white man who appeared to be in his early thirties. He had dark hair, blue eyes, and a thin nose and wore a dark suit that seemed much too nice for the neighborhood. What first struck her was his unusual smile, a cross between a “sneer” and a “smirk.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-6",
      "id": "ch05-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" She did not think he “fit in” with her tenants, and he unnerved her."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-7",
      "id": "ch05-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“Do you have a room for rent?” he asked.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Do you want one by the week or by the month?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“By the week.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-8",
      "id": "ch05-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She then unfastened the chain and led the stranger to Room 8. When she opened the door, he looked inside without actually entering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I don’t need the stove and refrigerator since I won’t be doing any cooking. I was thinking more of a sleeping room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She led him to the other wing, which had the only available sleeping room. She removed the padlock on the door. There was no door handle, but instead a wire coat hanger had been pushed through the opening and served as a handle. The room was small, with a single window with tattered green and gold floral curtains. The window looked out onto the alleyway between the two wings, but also provided a view of part of the Lorraine. He looked at the stained bed with a thin mattress laid haphazardly over the open springs. In front of the boarded fireplace was a portable gas heater. A naked lightbulb dangling from the cracked ceiling illuminated a ripped red sofa with a greasy pillow. A strong odor of disinfectant permeated the room. The last tenant, an elderly man, had died there a few weeks earlier. “I’ll take it. Where is the bathroom?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brewer pointed out the communal bathroom at the end of the long, narrow hallway. A hand-lettered sign—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOILET & BATH")]), _vm._v("—was tacked on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly the door of the room next to them opened. Forty-six-year-old Charlie Stephens, an unemployed tuberculosis patient, peered into the hallway. He stared for a moment at the new tenant."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-9",
      "id": "ch05-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Stephens had a wrench in his hand. “I’ve got the tank working,” he said to Bessie Brewer. “All right, Charlie,” she said as he returned to his room. “He usually drinks,” Brewer said to Willard, pointing toward Stephens’s room."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-10",
      "id": "ch05-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" What she did not tell her new tenant—though it probably would have pleased him—was that his other neighbors were mostly either drunks or invalids. In his wing, where the new boarder had settled into Room 5B, there was Stephens in Room 6B, who besides having a drinking problem also had to care for a bedridden wife; in Room 1B was Jessie Ledbetter, a deaf-mute; Rooms 2B and 3B were vacant; in Room 4B was Willie Anschutz, the only tenant who was actually employed (at the Duvall Transfer Company)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-11",
      "id": "ch05-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In the adjoining wing, besides Brewer and her husband, Room 3 had Bertie Reeves, an elderly man who was hard of hearing and had poor eyesight; Room 4 had Harold Vance, an older man who had been on a two-day drunk; Room 5 had T. L. Messer, a man of eighty who was almost deaf and suffered from senility; Room 7 had Frank Marley, an elderly man who usually was so drunk that he seldom came out of his room; Room 9 had Harold Carter, whose weakness was cheap wine; Room 10 had Leonard Eaton, in his early sixties and a longtime resident of the rooming house who was often passed out in his room from too much alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Bessie Brewer took the new tenant back to her office. He gave his name as John Willard, and when told the rent was $8.50 per week, he paid her with a twenty-dollar bill. He left her office without asking her about the padlock, which most people rented so they could lock the door when they were out. She did not see him again.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("About half an hour after Willard had checked into the rooming house, he showed up several blocks away at the York Arms Company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Could I help you?” asked Ralph Carpenter, a salesman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need a pair of field glasses,” Willard said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carpenter was low on binoculars. “All I have is a pair selling for two hundred dollars and another around ninety.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a little expensive,” said Willard, turning to go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute,” said Carpenter. He went to the display window and retrieved a pair of Bushnell binoculars priced at $39.95. Willard raised them to his eyes and seemed to like them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are there instructions in the box?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The question seemed odd to Carpenter, since it was hard to imagine an easier device to use than binoculars. “You really don’t need instructions, you just need to place them to your eyes and adjust the eye pieces.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-12",
      "id": "ch05-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" Willard agreed to take them, paid the $41.55 (including tax) in cash, and quickly left."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-05-2",
      "id": "fn05-2"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Willard drove back to the rooming house, but he had lost his previous parking place at the curb directly in front of Jim’s Grill. Instead, he had to park a few car lengths beyond the rooming-house entrance. He turned off the motor but did not immediately get out of the car."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-05-3",
      "id": "fn05-3"
    }
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the street from the rooming house was the Seabrook Wallpaper Company. Elizabeth Copeland, a customer service representative, finished work at 4:30 and was waiting for her husband to pick her up. As she was looking out the front showroom window for her husband’s car, she saw the Mustang drive up and park across the street. The driver sat inside as though he were waiting for someone or something."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-13",
      "id": "ch05-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Another woman, Frances Thompson, was waiting for her daughter to pick her up. She also saw the Mustang pull up about 4:30."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-14",
      "id": "ch05-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Thompson called out to one of her coworkers, Peggy Hurley, that her husband had arrived for her. When Hurley came to the window, she shook her head. “No, it’s not Charlie—we’ve got a Falcon. That’s a Mustang.” It was about 4:45 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-15",
      "id": "ch05-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" When Peggy Hurley’s husband arrived just a few minutes later, he also saw the Mustang and a lone white man sitting in the driver’s seat."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-16",
      "id": "ch05-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Fifteen minutes later, two men entering Jim’s Grill saw the Mustang, but it was empty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-17",
      "id": "ch05-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one saw Willard reenter the rooming house. Stephens heard someone in Room 5B walking around, and sometimes the door opened and footsteps headed to the bathroom at the far end of the hallway."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-18",
      "id": "ch05-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Stephens was aware that the tenant in 5B was spending a lot of time in the bathroom, but he heard the toilet flush only once. He later estimated that the person probably stayed in the bathroom for a total of twenty to thirty minutes. Willie Anschutz twice tried to use the bathroom to pour out some water he had used to wash dishes, but each time it was occupied. Anschutz knocked on Stephens’s door and angrily inquired about who was keeping the bathroom occupied. “The new tenant,” said Stephens, nodding with his head to the empty Room 5B."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch05-05-19",
      "id": "ch05-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the street at the Lorraine, King and his staff were having their raucous pillow fight. King had less than an hour to live.")]), _vm._v(" "), _c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-1",
      "id": "fn05-05-1"
    }
  }, [_vm._v("*")]), _vm._v(" On April 4, Memphis Police Tactical (TACT) Units, which had been formed after the March 28 violence, were pulled back five blocks from the immediate vicinity around the Lorraine. Some charge that was a lessening of security that made King an easier target. However, the TACT squads were not there to protect King, but instead to ensure there was no repeat of the recent rioting, firebombing, and looting. They were an obvious reminder to King that the Memphis police did not intend to tolerate any further civil disturbance. So it is not surprising to learn that when the House Select Committee on Assassinations investigated the issue of the TACT squad removal, it discovered that the request to move the units away from the motel actually came from an unidentified member of King’s party.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1-1"
  }, [_vm._v("That same afternoon, Detective Redditt was removed from his surveillance post when a threat was made on his life. That threat later turned out to be bogus. Although a black police officer replaced Redditt, since the assassination Redditt has given numerous interviews in which he contended that his removal was evidence that King’s security had been deliberately stripped away. However, when the Select Committee grilled Redditt, he admitted that his job was to surveil King, not protect him. Moreover, he acknowledged that it was “absolutely false” when he had implied he was part of a security detail. He apologized for his earlier statements. The committee concluded that Redditt had “knowingly allowed the nature of his job on the day of the assassination to be misrepresented and exploited by advocates of conspiracy theories” and that his conduct “was reprehensible” (HSCA Rpt., pp. 549–55).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1-1"
  }, [_vm._v("Finally, two black firemen were also transferred from the fire station the day before the assassination. Conspiracists have charged that their removal was to facilitate the assassin’s escape the following day. Actually, it was Detective Redditt who requested they be transferred, since he thought they were so sympathetic to King and the strikers that they might interfere with his surveillance operation (HSCA Rpt., p. 556).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-2",
      "id": "fn05-05-2"
    }
  }, [_vm._v("*")]), _vm._v(" If the tenants at the rooming house left a lot to be desired as witnesses, the FBI and Memphis police did not have much more help from Ralph Carpenter, who ended up in a mental institution a couple of months after the assassination (MURKIN 4442–4500, section 57, p. 133).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn05-3",
      "id": "fn05-05-3"
    }
  }, [_vm._v("†")])]), _vm._v(" Some witnesses saw a Mustang parked directly in front of Jim’s Grill, while others saw it some fifty to sixty feet just past the Canipe Amusement Company. That led to a conspiracy theory that there were two Mustangs. However, not all the witnesses, especially those in Jim’s Grill, are precise or accurate about the time they saw the car. What the witnesses are describing, undoubtedly, is that Willard moved the car from Jim’s to get the binoculars, and then had to park further away when he returned.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb9ee61","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 90
// module chunks = 0